import { API_BASE_URL } from "../../../configurations/configurations";
import { mainApiSlice } from "../api/mainApiSlice";

export const solutionsApi = mainApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSolutionsList: builder.query({
      query: ({ adminId }) => ({
        url: `${API_BASE_URL}/solutions/${adminId}`,
        method: "GET",
      }),
      providesTags: (result) => {
        if (result && Array.isArray(result)) {
          return [
            ...result.map(({ id }) => ({
              type: "Solution",
              id,
            })),
            { type: "SolutionsList", id: "LIST" },
          ];
        }
        return [{ type: "SolutionsList", id: "LIST" }];
      },
    }),
    updateSolutionsList: builder.mutation({
      query: ({ adminId, solutions }) => ({
        url: `${API_BASE_URL}/solutions/${adminId}`,
        method: "PUT",
        body: solutions,
      }),
      invalidatesTags: (result, error, solutions) => [
        { type: "SolutionsList", id: "LIST" },
      ],
    }),
  }),
});

export const { useGetSolutionsListQuery, useUpdateSolutionsListMutation } =
  solutionsApi;
